module.exports = __webpack_public_path__ + "img/download-3-2.74b56e35.png";